/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  AiFillBell,
  AiOutlineQuestionCircle,
  AiOutlineSetting,
} from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";
import { fetchProfile } from "../../hooks/authProfile";
import { logout } from "../../Auth/Hooks/authSlice";
import { clearAuthSession } from "../../utils/authSession";

import "./Header.css";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [openPopup, setOpenPopup] = useState(false);

  useEffect(() => {
    dispatch(fetchProfile());
  }, [dispatch]);

  const { data: profile } = useSelector((state) => state.profile || {});

  const displayName     = profile?.account?.name     ?? profile?.name     ?? "Admin";
  const displayUsername = profile?.account?.username ?? profile?.username ?? "";
  const displayEmail    = profile?.account?.email    ?? profile?.email    ?? "";
  const displayJoinDate = profile?.created_at
    ? new Date(profile.created_at).toLocaleString("id-ID")
    : null;

  const roleLabel = (() => {
    const r = localStorage.getItem("userRole");
    if (r === "Head Office")    return "Head Office";
    if (r === "Kantor Cabang")  return "Branch Office";
    if (r === "insured")        return "Tertanggung";
    if (r === "workshop")       return "Bengkel";
    return r ?? "";
  })();

  const handleOpenPopup = () => {
    setOpenPopup(true);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  const handleLogout = () => {
    try {
      dispatch(logout());
      queryClient.clear();
      clearAuthSession();
      Swal.fire({
        icon: "success",
        title: "Logout Berhasil",
        text: "Anda telah berhasil keluar.",
      }).then(() => {
        navigate("/", { replace: true });
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Logout Gagal",
        text: "Terjadi kesalahan saat logout. Silakan coba lagi.",
      });
    }
  };

  return (
    <>
      <header className="header">
        <div className="header-left">
          <img src="/logo.png" alt="Logo Jastan" className="logo" />
        </div>

        <div className="header-right">
          {/* <AiFillBell className="icon" />
          <AiOutlineQuestionCircle className="icon" />
          <AiOutlineSetting className="icon" /> */}
          <button type="button" className="header-profile" aria-label="Buka menu profil" aria-expanded={openPopup} onClick={handleOpenPopup}>
            <span className="username">{displayName}</span>
            <span className="avatar-button" aria-hidden="true">
              {displayName.charAt(0).toUpperCase()}
            </span>
          </button>
        </div>
      </header>

      {/*Popup Profile*/}
      {openPopup && (
        <div className="profile-popup" onMouseLeave={handleClosePopup}>
          <div className="profile-avatar">
            <div className="avatar-circle">
              {displayName.slice(0, 2).toUpperCase()}
            </div>
          </div>
          <div className="profile-info">
            <p className="profile-info-name">{displayName}</p>
            {displayUsername && <p className="profile-info-username">@{displayUsername}</p>}
            {displayEmail    && <p className="profile-info-email">{displayEmail}</p>}
            {roleLabel       && <span className="profile-role-badge">{roleLabel}</span>}
            {displayJoinDate && <p className="profile-info-join">Bergabung: {displayJoinDate}</p>}
          </div>
          <div className="profile-actions">
            <button
              onClick={() => {
                const role = localStorage.getItem("userRole");
                if (role === "Head Office") navigate("/dashboard-headoffice/profile");
                else if (role === "insured") navigate("/dashboard-insured/profile");
                else if (role === "workshop") navigate("/dashboard-workshop/profile");
                else navigate("/dashboard-branch/profile");
              }}
              className="btn-profile"
            >
              Profil
            </button>
            <button onClick={handleLogout} className="btn-logout">
              Keluar
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
